import { Stack } from '@mui/material';
import Typography from '@mui/material/Typography';
import { DiscountBadge } from '@shared/components/display/DiscountBadge/DiscountBadge';

interface PriceSectionProps {
  price: number;
  /** True when the price is malformed/missing catalog data rather than a genuine $0 — renders as unavailable instead of $0. */
  priceUnavailable?: boolean;
  priceSuffix?: string;
  discountTag?: string;
  discountMessage?: string;
  oneTimeFee?: number;
}

export const PriceSection = ({
  price,
  priceUnavailable,
  priceSuffix = '/ month',
  discountTag,
  discountMessage,
  oneTimeFee,
}: PriceSectionProps) => (
  <Stack spacing={1.25} useFlexGap>
    <Stack direction="row" alignItems="baseline" spacing={0.5} useFlexGap>
      <Typography variant="price.primary" className="PlanCard-price">
        {priceUnavailable ? 'Price unavailable' : `$${price}`}
      </Typography>
      {!priceUnavailable && (
        <Typography variant="price.suffix" className="PlanCard-price">
          {priceSuffix}
        </Typography>
      )}
    </Stack>
    {/* oneTimeFee > 0 guards against the catalog defaulting a missing/malformed amount to 0,
        which would otherwise render as "+ $0 one-time installation fee". */}
    {oneTimeFee != null && oneTimeFee > 0 && (
      <Typography variant="body.sm" color="text.secondary">
        + ${oneTimeFee} one-time installation fee
      </Typography>
    )}
    {discountTag && (
      <DiscountBadge>
        <Typography variant="label.button" className="PlanCard-discountTag" textTransform="uppercase">
          {discountTag}
        </Typography>
      </DiscountBadge>
    )}
    {discountMessage && (
      <Typography variant="label.button">{discountMessage}. Discount applied at checkout</Typography>
    )}
  </Stack>
);
